/**
 * Map Constants
 * Common map-related constants used across the application
 */

/**
 * Mamison Resort coordinates
 * Static point always displayed on cultural object maps
 */
export const MAMISON_RESORT = {
  documentId: "mamison-resort",
  title: "Курорт Мамисон",
  coordinates: "42.662097, 43.839810",
} as const;

/**
 * Default map center (resort location)
 */
export const DEFAULT_MAP_CENTER = "42.676089, 43.805767";

/**
 * Default zoom levels
 */
export const MAP_ZOOM = {
  CLOSE: 18,
  MEDIUM: 14,
  FAR: 12,
  VERY_FAR: 10,
} as const;
